import { createStore } from "reusable";
import useChainList from "../hooks/useChainList";

export default createStore(() => useChainList());
